import { Form } from "src/app/services/response-models/form.response.model";

export class LoadSelectedForm {
    public static readonly type = "[Forms] Load selected form";

    constructor(public payload: Form) {}
}
